<template>
  <div>
    <CCard class="m-auto">
      <CCardHeader class="grey-header">
        <div class=" d-flex flex-flow-column">
          <div>
            <strong>{{ $t('systemTicketNow.title')}}</strong>
          </div>
          <p class="desc">{{ $t('systemTicketNow.desc')}}</p>
        </div>
      </CCardHeader>
      <br />
      <br />
        <div class="w-100 ">
            <CRow class="m-auto jc-center-row">
                <cBreadCrumb :item="navBarItems" :toNav="false" @getStatus="getNavBarStatus" class="breadcrumbs-approve"></cBreadCrumb>
            </CRow>
            <div class="w-100 max-w-400 m-auto">
            <div class="m-auto " v-if="alertValue">
                <br/>
                <br/>
                <CAlert show color="danger" class="d-flex">
                    <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                        <p class="pr-2"  v-for="(value,index) in alertValue.valueList" :key="index">
                            {{value}}
                        </p>
                    </div>
                    <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                        <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                    </div>
                    <div  v-if="alertValue&&alertValue.constructor==String">
                        <p  >
                            {{alertValue}}
                        </p>
                    </div>
                </CAlert>

            </div>
            <cAlertModal
                    v-if="isShowAlertModal"
                    :key="'systemtcktnow'+alertCount"
                    :buttonList="modalButton"
                    :status="modalStatus"
                    :isShowIcon="true"
                    :show="isShowAlertModal"
                    :desc="confirmTxt"
            ></cAlertModal>
            </div>
            <div class="m-auto">
                <div class="m-auto" v-if="navBarItems[0].details">
                    <ValidationObserver v-slot="{ handleSubmit }">
                       <form class="w-100 max-w-400 m-auto">
                        <CCardBody class=" max-w-1100 m-auto pt-0px">
                            <br />
                            <h3  v-if="GET_ORDER_ID">{{ $t('systemTicketNow.reservationId')}} : {{GET_ORDER_ID}}</h3>
                            <br />

                            <div v-if="agtUserLs && agtUserLs.b2bUsers" class="multiselect-single-wrap-text-ellipsis">
                                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                    <label >{{ $t('systemTicketNow.dpTitle')}}</label>
                                    <multiselect

                                            :allow-empty="false"
                                            :label="'firstname'"
                                            :showLabels="false"
                                            :clearOnSelect="false"
                                            v-model="selectedAgtUser"
                                            :options="agtUserLs.b2bUsers"
                                            :multiple="false"
                                            :track-by="'userid'"
                                            :placeholder="$t('systemTicketNow.dpPlaceholder')"
                                            v-on:input="getSelectedAgtUser"
                                            :custom-label="agtUserCustomeLabel"
                                            class="mt-auto"
                                    >

                                        <template slot="option" slot-scope="props">
                                            <div>
                    <span>
                      {{ props.option.firstname}}

                    </span>
                                            </div>
                                        </template>

<span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                    </multiselect>
                                    <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <br />
                        </CCardBody>
                        
                    </form>
                        <div v-if="navBarItems[0].details" class="card-footer d-flex justify-content-between">
            <div class="d-flex justify-content-end">
                <CCol class="pl-0px">
                    <CButton color="danger" @click="beforeLeave()" class="action-c-btn">{{ $t('systemTicketNow.cancelBtn')}}</CButton>
                </CCol>
                <CCol  class="pr-0px">
                    <CButton v-if="alertValue!=null"
                            color="success"
                           
                            class="action-c-btn white-space-pre"
                    >{{ $t('systemTicketNow.sendVerCode')}}</CButton>
                     <CButton v-if="alertValue==null"
                            color="success"
                            @click.prevent="handleSubmit(toSendVerificationCode)"
                            class="action-c-btn white-space-pre"
                    >{{ $t('systemTicketNow.sendVerCode')}}</CButton>
                </CCol>
            </div>
        </div> 

                    </ValidationObserver>
                </div>
                <div class="m-auto" v-if="navBarItems[1].details">
                    <ValidationObserver v-slot="{ handleSubmit }">
                      
                       <form class="w-100 max-w-400 m-auto">
                        <br />
                        <br />
                        <span class="font-weight-bold f-16px text-center" v-if="GET_ORDER_ID">{{ $t('systemTicketNow.reservationId')}} : {{GET_ORDER_ID}}</span>
                        <br />
                        <br />
                        <div class="text-left">
                            {{ $t('systemTicketNow.verdesc',{name:selectedAgtUser.firstname,email:selectedAgtUser.emailid})}}
                        </div>
                           <br />
                           <div class="text-center">
                               {{ $t('systemTicketNow.verMsg')}}
                           </div>

                        <br />
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <CRow>
                                <CCol>{{ $t('systemTicketNow.verLabel')}} :</CCol>
                                <CCol>
                                    <!-- <cTextInputComponent
                                            v-model="verification.code"
                                            class="inner-label-none"
                                            rules="required"/> -->
                                    <input maxlength="6" class="single-code-input" v-model="verification.code">
<!--                                    <div class="d-flex">-->
<!--                                        <input maxlength="1" class="single-code-input" v-model="verification.code">-->
<!--                                        <input maxlength="1" class="single-code-input" >-->
<!--                                        <input maxlength="1" class="single-code-input" >-->
<!--                                        <input maxlength="1" class="single-code-input" >-->
<!--                                        <input maxlength="1" class="single-code-input" >-->
<!--                                        <input maxlength="1" class="single-code-input" >-->


<!--                                    </div>-->

                                </CCol>

                            </CRow>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                            <br />
                        </ValidationProvider>
                        </form>
<div v-if="navBarItems[1].details" class="card-footer d-flex justify-content-between bt-none">
            <div class="d-flex justify-content-end">
                <CCol class="pl-0px">
                    <CButton color="danger" @click="beforeLeave()" class="action-c-btn">{{ $t('systemTicketNow.goBackBtn')}}</CButton>
                </CCol>
                <CCol class="pr-0px">
                    <CButton
                    @click.prevent="handleSubmit(toVerifyCode)"
                            color="success"
                            class="action-c-btn"
                    >{{ $t('systemTicketNow.verBtn')}}</CButton>
                </CCol>
            </div>
        </div>
                    </ValidationObserver>
                </div>
                <div class="m-auto" v-if="navBarItems[2].details">
                  <br />
                  <br />
                  <div class="text-center">
                        {{ $t('systemTicketNow.verSucc')}} 
                    </div>
                    <br />
                    <br />
                    <div class="text-center">
                        {{ $t('systemTicketNow.cnfrmTck')}} <strong class="pl-2"> {{this.GET_ORDER_ID}} ? </strong>
                    </div>

                    <br />
                    <br />

                    <div v-if="navBarItems[2].details" class="card-footer d-flex justify-content-between bt-0">
            <div class="d-flex justify-content-end">
                <CCol class="pl-0px">
                    <CButton color="danger" @click="beforeLeave()" class="action-c-btn">{{ $t('systemTicketNow.goBackBtn')}}</CButton>
                </CCol>
                <CCol class="pr-0px">
                    <CButton
                            color="success"
                            @click="confirmToIssueTcktNow()"
                            class="action-c-btn white-space-pre"
                    >{{ $t('systemTicketNow.issueBtn')}}</CButton>
                </CCol>
            </div>
        </div>

                </div>


            </div>

        </div>
        <!-- <div v-if="navBarItems[0].details" class="card-footer d-flex justify-content-between">
            <div class="d-flex justify-content-end">
                <CCol class="pl-0px">
                    <CButton color="danger" @click="goBack()" class="action-c-btn">{{ $t('systemTicketNow.cancelBtn')}}</CButton>
                </CCol>
                <CCol class="pr-0px">
                    <CButton
                            color="success"
                            
                            class="action-c-btn white-space-pre"
                    >{{ $t('systemTicketNow.sendVerCode')}}</CButton>
                </CCol>
            </div>
        </div> -->
       
        <!-- <div v-if="navBarItems[1].details" class="card-footer d-flex justify-content-between bt-none">
            <div class="d-flex justify-content-end">
                <CCol class="pl-0px">
                    <CButton color="danger" @click="goBack()" class="action-c-btn">{{ $t('systemTicketNow.goBackBtn')}}</CButton>
                </CCol>
                <CCol class="pr-0px">
                    <CButton
                            color="success"
                            class="action-c-btn"
                    >{{ $t('systemTicketNow.verBtn')}}</CButton>
                </CCol>
            </div>
        </div> -->
        <!-- <div v-if="navBarItems[2].details" class="card-footer d-flex justify-content-between bt-0">
            <div class="d-flex justify-content-end">
                <CCol class="pl-0px">
                    <CButton color="danger" @click="goBack()" class="action-c-btn">{{ $t('systemTicketNow.goBackBtn')}}</CButton>
                </CCol>
                <CCol class="pr-0px">
                    <CButton
                            color="success"
                            @click="confirmToIssueTcktNow()"
                            class="action-c-btn"
                    >{{ $t('systemTicketNow.issueBtn')}}</CButton>
                </CCol>
            </div>
        </div> -->

    </CCard>

  </div>
</template>
<script>
import {
  COMPONENT_NAME,
  PATHNAME,
  BREADCRUMB_STATUS,
  ALERT_MODAL_STATUS
} from "../../../../../util/constants";
import { ValidationObserver, ValidationProvider, localize } from "vee-validate";
import Logger from "../../../../../services/logger";
import BaseConfiguration from "../../../../../config/base";
import cTextInputComponent from "../../../../../components/form/cTextInputComponent";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../../config/API_DATA";
import cBreadCrumb from "../../../../../components/breadcrumb/cBreadCrumb";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../../util/apiValidate.js";
import apiGetAgentUserByOrderId from "../../../../../services/apiGetAgtUserByOrderId";
import apiSendVerificationCode from "../../../../../services/apiSendVerificationCode";
import apiVerifyCode from "../../../../../services/apiVerifyCode";
import apiIssuedVerifiedOrderTicket from "../../../../../services/apiIssuedVerifiedOrderTicket";
import Multiselect from "vue-multiselect";
import router, {navigate, goBack, updateDataEdited} from "../../../../../router/index";
import cAlertModal from "../../../../../components/form/cAlertModal";
import {
  cloneData,
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody
} from "../../../../../util/util";

export default {
  name: COMPONENT_NAME.SYSTEM_TICKET_NOW,
  components: {
    cAlertModal,
    ValidationObserver,
    ValidationProvider,
      cTextInputComponent,
    Multiselect,
    cBreadCrumb
  },
  data: () => ({
    navBarItems: null,
    agtUserLs: [],
    selectedAgtUser: null,
    verification: {
      id: null,
      code: null
    },
    alertValue:null,
    alertCount:0,
    isShowAlertModal: false,
    modalStatus: ALERT_MODAL_STATUS.INFO,
    modalButton: null,
    confirmTxt:null
  }),
  computed: {
    ...mapGetters("sTicketingQueue", {
      GET_ORDER_ID: "GET_ORDER_ID"
    })
  },

  async created() {
    // updateDataEdited(true);
    this.getNavBarItems();
    this.agtUserLs = await this.getAgentUserList();
  },

  

  methods: {
    ...mapActions("sTicketingQueue", {

                SET_ORDER_ID: "SET_ORDER_ID"
            }),

       agtUserCustomeLabel(option) {
      return `${option.firstname}  (${option.emailid})  ${option.roles[0]}`;
    },
    
    navToTicketingQueue() {
        try {
          if(BaseConfiguration.isDebug) console.log("navToTicketingQueue");
          updateDataEdited(false);
          navigate(PATHNAME.TICKETING_QUEUE);
          this.getNavBarStatus(this.navBarItems);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SYSTEM_TICKET_NOW,
                  "error in navToTicketingQueue",
                  err.toString(),
                  "navToTicketingQueue",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
    }, 

        showDetails() {
          
                try {
                    if (BaseConfiguration.isDebug) console.log("showDetails");
                    for (let i = 0; i <= this.navBarItems.length - 1; i++) {
                        if (this.navBarItems[i].details == true) {
                            this.navBarItems[i + 1].details = true;
                            this.navBarItems[i].details = false;
                            break;
                        }
                    }
                    this.getNavBarStatus(this.navBarItems, true);
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in showDetails",
                        err.toString(),
                        "showDetails",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
        },
     async beforeLeave() {
     let that = this;
      this.$dialog.confirm('<stong>Are you sure you want to leave this page. </stong><div></div>')                    
                    .then(function (dialog) {
                      that.goBack();
                   
                    })
                    .catch(function () {
                      
                       for (let i = 0; i < that.navBarItems.length; i++) {
                        if (that.navBarItems[i].details == true) {
                            that.navBarItems[i].details = true;
                        }
                    }
                      
                    });
    },

    goBack() {
                try {
               
                    for (let i = 0; i < this.navBarItems.length; i++) {
                        if (this.navBarItems[i].details == true) {
                            if (this.navBarItems[i].id == 0) {
                                this.navToTicketingQueue();
                            } else if (this.navBarItems[i].id == 1) {
                                this.navBarItems[i].details = false;
                                this.navBarItems[i - 1].details = true;
                                this.navBarItems[i - 1].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PRESENT_ITEM;
                                this.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM;

                            } else if (this.navBarItems[i].id == 2) {
                                this.navToTicketingQueue();
                            }
                        }
                    }
                     
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.SYSTEM_TICKET_NOW,
                        "error in goBack",
                        err.toString(),
                        "goBack",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
     },

       showAlertModal(status, val) {
                this.isShowAlertModal = true;
                this.alertCount += 1;
                this.modalStatus = status;

                if (status == ALERT_MODAL_STATUS.INFO) {
                    this.modalButton = [
                        {
                            name: this.$t('systemTicketNow.cancel'),
                            func: this.toggleShowAlertModal
                        },
                        {
                            name: this.$t('systemTicketNow.yes'),
                            func:  this.issueVerifiedTicket
                        }
                    ];
                } else if (status == ALERT_MODAL_STATUS.SUCCESS || status == ALERT_MODAL_STATUS.FAIL) {
                    this.modalButton = [
                        {
                            name: this.$t('systemTicketNow.ok'),
                            func: this.navToTicketingQueue 
                        }
                    ];
                }
                 
                this.confirmTxt = val;
            },
             async toggleShowAlertModal() {
                
                
                this.isShowAlertModal = !this.isShowAlertModal;
                this.modalStatus = ALERT_MODAL_STATUS.INFO;
            },

            

             confirmToIssueTcktNow() {
                try {
                    if (BaseConfiguration.isDebug) console.log("confirmToIssueTcktNow");
                    this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t('systemTicketNow.tcktCnfrm'),
                        
                    );
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXTENSION_SETUP,
                        "error in confirmToIssueTcktNow",
                        err.toString(),
                        "confirmToIssueTcktNow",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            
    getSelectedAgtUser(pSelAgtUser) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedAgtUser");
        this.selectedAgtUser = pSelAgtUser;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getSelectedAgtUser",
          err.toString(),
          "getSelectedAgtUser",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      
    },

    async issueVerifiedTicket() {
      let retValue;
      try {
        let issueVerifiedTcktReq;
        if (this.verification.id) {
          issueVerifiedTcktReq = apiIssuedVerifiedOrderTicket.buildRequest(
            this.verification
          );
        }
        if (issueVerifiedTcktReq) {
          let issueVerifiedTcktRes = await apiIssuedVerifiedOrderTicket.getResponse(
            issueVerifiedTcktReq
          );

          if (VALIDATE_SUCCESS_RES(issueVerifiedTcktRes)) {
            retValue = issueVerifiedTcktRes.data.data;
            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t('systemTicketNow.succTxt'),
                        
                            );
                            this.alertValue = null;
            
          } else {
           
            let error = getErrorMessage(issueVerifiedTcktRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
             this.showAlertModal(
                                ALERT_MODAL_STATUS.FAIL,
                                this.alertValue
                            );
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getting response from issueVerifiedTicket API",
          err.toString(),
          "issueVerifiedTicket",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async toVerifyCode() {
      let retValue;
      try {
        let verifyCodeReq;
        if (this.verification.id && this.verification.code) {
          
          verifyCodeReq = apiVerifyCode.buildRequest(this.verification);
        }
        if (verifyCodeReq) {
          let verifyCodeRes = await apiVerifyCode.getResponse(verifyCodeReq);

          if (VALIDATE_SUCCESS_RES(verifyCodeRes)) {
            retValue = verifyCodeRes.data.data;
            if(retValue.isVerified) {
              this.showDetails();
            }
            this.alertValue=null;
          } else {
            let error = getErrorMessage(verifyCodeRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getting response from toVerifyCode API",
          err.toString(),
          "toVerifyCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async toSendVerificationCode() {
      let retValue;
      try {
        let sendVerCodeReq;
        if (this.alertValue==null&&this.GET_ORDER_ID && this.selectedAgtUser) {
          sendVerCodeReq = apiSendVerificationCode.buildRequest(
            this.GET_ORDER_ID, this.selectedAgtUser.userid
          );
        }
        if (sendVerCodeReq) {
          let sendVerCodeRes = await apiSendVerificationCode.getResponse(
            sendVerCodeReq
          );

          if (VALIDATE_SUCCESS_RES(sendVerCodeRes)) {
            retValue = sendVerCodeRes.data.data;
            if(retValue.verificationCodeSend){
              this.showDetails();
                this.verification.id=parseInt(retValue.verificationId);
            }
            this.alertValue=null;
          } else {
            let error = getErrorMessage(sendVerCodeRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getting response from toSendVerificationCode API",
          err.toString(),
          "toSendVerificationCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getAgentUserList() {
      let retValue;
      try {
        let getAgtUserReq;
        if (this.GET_ORDER_ID!=null) {
          
          getAgtUserReq = apiGetAgentUserByOrderId.buildRequest(
            this.GET_ORDER_ID
          );
        }
        if (getAgtUserReq) {
          let getAgtUserRes = await apiGetAgentUserByOrderId.getResponse(
            getAgtUserReq
          );

          if (VALIDATE_SUCCESS_RES(getAgtUserRes)) {
            retValue = getAgtUserRes.data.data.bookingStatus;
            this.alertValue=null;
          } else {
            let error = getErrorMessage(getAgtUserRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } 
        // else {
        //   throw "invalid agent";
        // }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getting response from getAgentUserList API",
          err.toString(),
          "getAgentUserList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getNavBarItems() {
      try {
        this.navBarItems = [
          {
            id: 0,
            name: "Select User",
            status:
              BREADCRUMB_STATUS.BREADCRUMB_ITEM +
              " " +
              BREADCRUMB_STATUS.PRESENT_ITEM,
            details: true
          },
          {
            id: 1,
            name: "Verification",
            status: BREADCRUMB_STATUS.BREADCRUMB_ITEM,
            details: false
          },

          {
            id: 2,
            name: "Issue Ticket",
            status: BREADCRUMB_STATUS.BREADCRUMB_ITEM,
            details: false
          }
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getNavBarItems",
          err.toString(),
          "getNavBarItems",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getNavBarStatus(pvalue, isNxt) {
      // alert(JSON.stringify(pvalue));
      try {
        if (BaseConfiguration.isDebug)
          console.log("getNavBarStatus" + JSON.stringify(pvalue));

        for (let i = 0; i < this.navBarItems.length; i++) {
          if (isNxt) {
                            if (this.navBarItems[i].details == false) {
                                this.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PRESENT_ITEM;
                            } else {
                                this.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PRESENT_ITEM;
                                break;
                            }
                        } else if (
                            isNxt == false &&
                            this.navBarItems[i].details == true
                        ) {
                            this.navBarItems[i].status =
                                BREADCRUMB_STATUS.BREADCRUMB_ITEM;
                            this.navBarItems[i].details = false;

                            this.navBarItems[i - 1].details = true;
                        }
          if (isNxt == undefined) {
            if (i == pvalue.id) {
              this.navBarItems[i].status =
                BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                " " +
                BREADCRUMB_STATUS.PRESENT_ITEM;
              this.navBarItems[i].details = true;
            } else if (i < pvalue.id) {
              this.navBarItems[i].status =
                BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                " " +
                BREADCRUMB_STATUS.PAST_ITEM;
              this.navBarItems[i].details = false;
            } else {
              this.navBarItems[i].status = BREADCRUMB_STATUS.BREADCRUMB_ITEM;
              this.navBarItems[i].details = false;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getNavBarStatus",
          err.toString(),
          "getNavBarStatus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
  beforeCreate() {
            addClassToBody(COMPONENT_NAME.SYSTEM_TICKET_NOW);
        },

        beforeDestroy() {
            removeClassBody();
            this.SET_ORDER_ID(null);
        },

        
};
</script>